var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-decoration-4',{staticClass:"decoration-container",attrs:{"reverse":_vm.reverse,"color":_vm.color,"dur":_vm.dur}})
}
var staticRenderFns = []

export { render, staticRenderFns }